import { useEffect } from 'react';
import { Link, useHistory, useRouteMatch, Switch } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Col, Menu, Row, Space } from 'antd';

import CustomRoute from '@/components/_common/CustomRoute';
import ContentWrapper from '@/components/_common/ContentWrapper';

import './style.less';
import { PageProps } from '@/types/PageProps';
import { useWindowSize } from '@/hooks';
import { DownOutlined } from '@ant-design/icons';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
import AccessDenied from '@/components/_common/AccessDenied';

const SettingsPage = ({ route }: PageProps) => {
  const history = useHistory();
  const match = useRouteMatch();
  const { width } = useWindowSize();

  useEffect(() => {
    if (match.isExact) {
      history.push(`/app/settings/emailSettings`);
    }
  }, []);

  const historyKeys = history?.location?.pathname?.split('/');
  const settingsKeyIndex = historyKeys.indexOf('settings');
  const selectedMenuKey = historyKeys[settingsKeyIndex + 1];

  if (
    !hasPermissions([
      Authorities.CONFIGURATION_USER_EDIT_SYSTEM_SETTINGS,
      Authorities.CONFIGURATION_USER_SYSTEM_SETTINGS,
    ])
  ) {
    return <AccessDenied />;
  }

  return (
    <ContentWrapper>
      <Row
        className="settings-wrapper"
        gutter={[12, 12]}
        align={width <= 992 ? 'middle' : 'top'}
      >
        <Col span={24} md={24} lg={6}>
          <Menu
            mode={width <= 992 ? 'horizontal' : 'inline'}
            className="menu"
            selectedKeys={[selectedMenuKey]}
            overflowedIndicator={
              <Space>
                Abrir Navegação <DownOutlined style={{ fontSize: '10px' }} />
              </Space>
            }
          >
            {route.routes
              .filter((r) => hasPermissions(r.permissions || []))
              .map((r) => (
                <Menu.Item key={r.key}>
                  <Link to={r.path}>
                    <FormattedMessage id={r.name} />
                  </Link>
                </Menu.Item>
              ))}
          </Menu>
        </Col>

        <Col span={24} md={24} lg={18}>
          {route.routes.map((r) => (
            <div key={r.key}>
              <CustomRoute {...r} />
              <Switch>
                {r.routes?.map((iR) => (
                  <CustomRoute {...iR} />
                ))}
              </Switch>
            </div>
          ))}
        </Col>
      </Row>
    </ContentWrapper>
  );
};

export default SettingsPage;
